import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { Outlet, useParams } from 'react-router-dom';
import { StateMachineProvider, createStore } from 'little-state-machine';
import { fetchtrainee } from '../../../../Redux/slices/trainees';
import { useDispatch } from 'react-redux';
import { StepNav } from '../../../../Components/Reuseables';
import admin from '../../../../_routes/admin';

createStore({});

const STEPS = ['Step1', 'Step2', 'Step3'];

function Trainees() {
  const location = useLocation();
  const dispatch = useDispatch();

  const { id, edit: isEdit } = useParams();

  let pathname = location.pathname;
  const [step, setStep] = useState(pathname.split('/')[5]);

  // isEdit
  //     ? pathname.split('/').includes('admin')
  //       ? pathname.split('/')[6]
  //       : pathname.split('/')[5]
  //     : pathname.split('/').includes('admin')
  //     ? pathname.split('/')[4]
  //     : pathname.split('/')[3]

  useEffect(() => {
    isEdit
      ? pathname.split('/').includes('admin')
        ? pathname.split('/')[5]
        : pathname.split('/')[4]
      : pathname.split('/').includes(admin)
      ? pathname.split('/')[4]
      : pathname.split('/')[3];
    setStep(
      isEdit
        ? pathname.split('/').includes('admin')
          ? pathname.split('/')[5]
          : pathname.split('/')[4]
        : pathname.split('/').includes('admin')
        ? pathname.split('/')[4]
        : pathname.split('/')[3]
    );
  }, [pathname]);
  useEffect(() => {
    if (isEdit) {
      dispatch(fetchtrainee(`/profile/participant/${id}/`));
    }
  }, []);
  return (
    <div className="card">
      {/* <div className="card-header">
        <h3 className="text-primary d-flex justify-content-between">
          <FormattedMessage id="participants" />
          <Link className="btn btn-success me-2" to="">
            <FaPlus />
            <span className="ms-2"></span>

            <FormattedMessage id="add_new" />
          </Link>
        </h3>
      </div> */}
      <div className="card-body">
        {!pathname.split('/').includes('list') ? (
          <StepNav className="mb-3">
            {STEPS.map((title, index, { length }) => {
              let stepName;
              switch (step) {
                case undefined:
                  stepName = STEPS[0];
                  break;
                default:
                  stepName = STEPS[parseInt(step)];
              }
              let _class = 'bg-primary text-light';
              if (index == 0) {
                _class = `${_class} first-step`;
              }
              if (index + 1 === length) {
                _class = `${_class} last-step`;
              }
              return (
                <div key={index} className={title === stepName ? _class : ''}>
                  <span>
                    <small>{title}</small>
                  </span>
                </div>
              );
            })}
          </StepNav>
        ) : (
          ''
        )}

        <StateMachineProvider>
          <Outlet />
        </StateMachineProvider>
      </div>
    </div>
  );
}

export default Trainees;
